import script from "./SpvCard.vue?vue&type=script&setup=true&lang=js"
export * from "./SpvCard.vue?vue&type=script&setup=true&lang=js"

import "./SpvCard.vue?vue&type=style&index=0&id=320a556e&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-320a556e"]])

export default __exports__